import { envConfig } from 'config';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';

import { openSnackbar } from 'slices/snackbar';
import { logout } from 'slices/auth';

const baseApi = async (args, api, extraOptions) => {
  const response = await fetchBaseQuery({
    baseUrl: envConfig.apiBaseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
    }
  })(args, api, extraOptions);

  if (response.error?.status === 400) {
    api.dispatch(
      openSnackbar({
        open: true,
        message: response.error.data?.error?.[0] ?? response.error.data?.message,
        variant: 'alert',
        alert: {
          severity: 'error',
          color: 'error'
        },
        close: false
      })
    );
  } else if ([401, 403].includes(response.error?.status)) {
    api.dispatch(
      openSnackbar({
        open: true,
        message: 'Invalid token. Redirecting to login.',
        variant: 'alert',
        alert: {
          severity: 'error',
          color: 'error'
        },
        close: false
      })
    );
    api.dispatch(logout());
    window.location.href = '/login';
  }

  return response;
};

export default baseApi;
